import React, { Component } from "react";
import _ from "underscore";
import PropTypes from "prop-types";

class CDCModalInput extends Component {
  static propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    dataType: PropTypes.string,
    panelStatus: PropTypes.string,
    handleChange: PropTypes.func,
    isInvalid: PropTypes.bool,
    isRequired: PropTypes.bool,
  };

  static defaultProps = {
    value: "",
    placeholder: "",
    dataType: "",
    panelStatus: "",
    handleChange: _.noop,
    isRequired: false,
  };

  // When editing an address, we want to validate the input as soon as the edit stat is entered
  // This is because some imported data may be missing required fields, and we require them enter
  // Those values before they can submit
  state = {
    isDirty: this.props.dataType === "address" && this.props.panelStatus === "edit",
  };

  renderInput = () => {
    const showRequired = this.props.isRequired && this.props.value === "" && this.state.isDirty;
    if (this.props.dataType === "misc") {
      return (
        <React.Fragment>
          <div className="cdc-controller--input-label">
            Use the space below for any other contact information update. (e.g., education, career, solicitation
            preferences, marital status)
          </div>
          <textarea
            className={showRequired ? "cdc-controller--has-error" : null}
            rows={3}
            value={this.props.value}
            onChange={event => this.props.handleChange(event.target.value)}
            onBlur={() => this.setState({ isDirty: true })}
          />
          {showRequired ? <p className="cdc-controller--has-error">This field is required</p> : null}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <input
            className={this.props.isInvalid || showRequired ? "cdc-controller--has-error" : null}
            value={this.props.value}
            placeholder={this.props.placeholder}
            onChange={event => this.props.handleChange(event.target.value)}
            onBlur={() => this.setState({ isDirty: true })}
          />
          {this.props.isInvalid ? (
            <p className="cdc-controller--has-error">
              Not a valid {this.props.dataType === "phone" ? "phone number" : this.props.dataType}
            </p>
          ) : null}
          {showRequired ? <p className="cdc-controller--has-error">This field is required</p> : null}
        </React.Fragment>
      );
    }
  };

  render() {
    return (
      <div className="cdc-controller--input-container">
        {this.props.label ? <label className="cdc-controller--label-active">{this.props.label}</label> : null}
        {this.renderInput()}
      </div>
    );
  }
}

export default CDCModalInput;
